// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"iZ-z","subtitle":"jZ-z","wrapper":"kZ-z","leftArrow":"lZ-z","rightArrow":"mZ-z"};